import React, { Component } from "react";
import { AppContext } from "../utils/context";
import { request as xhr, queryString } from "../utils/request";
import { blankImage, formatCurrency } from "../utils/constants";
import Alert from "../components/Alert";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Button from "../components/Button";


class PrintSuper extends Component {

  render() {
    return (
      <div className={`container mx-auto py-6`}>
        <div className="max-w-xs rounded overflow-hidden mb-6 m-auto text-center">
          <ReactToPrint content={() => this.componentRef}>
            <PrintContextConsumer>
              {({ handlePrint }) => (
                <Button onClick={handlePrint} content="Print Ticket!" />
              )}
            </PrintContextConsumer>
          </ReactToPrint>
          </div>
          <Print {...this.props} ref={el => (this.componentRef = el)} />
        
      </div>
    );
  }
}

class Print extends Component {
    state = {
      data: false
    }
  componentDidMount = async () => {
    let qs = queryString.parse(this.props.location.search);
    let orderId = qs.orderId ? qs.orderId : qs.orderid;
    let hash = qs.hash ? qs.hash : (qs.orderhash ? qs.orderhash : '');
    let order = xhr.get(`api:/web/order/${orderId}/tickets`, { 'hash': hash });

    order.then(data => {
      this.setState({
        data
      })
    })

  }

  render() {
    const { data } = this.state;
    const { language } = this.context;

    return (
      <div className={`container mx-auto py-6`}>
        {data && data.tickets && data.tickets.map(ticket => (
          <div key={`ticket${ticket.id}`} className="max-w-xs rounded overflow-hidden mb-6 m-auto border border-grey-light">
            {data.nonprofit.barcode_position === "top" && (
              <div className="p-2">
                <img className="w-full" src={`data:image/png;base64,${ticket.barcode}`} alt="Barcode" />
              </div>
            )}
            <div className="p-2">
              <img                
                src={`${data.nonprofit.web_header_url}`}
                onError={(e) => { e.target.src = blankImage }}
                alt="Logo"
                className="block mx-auto"
              />
            </div>
            <div className="px-6 py-4 text-xl">
              {data.event !== null && (
                <p className="mb-4 font-bold text-center">{data.event.title}</p>
              )}             
            </div>

            <div className="px-6 py-4">
              {ticket.numbers.map(num => (
                <div key={num} className="font-bold text-xl text-center mb-2">{num}</div>
              ))}
            </div>
    
            { data.draws && (
                <div className="px-6 py-4 text-xs"> 
                    <div className="font-bold font-bold text-xl text-center mb-4">
                        <u>Prizes</u>
                    </div>
                    {data.draws.map(draw => (
                      <div className="mb-2">
                          <div className="flex justify-between">
                              <b><u>{draw.title}</u></b>
                          </div>
                          { draw.draw_at && (
                              <div className="flex justify-between">
                                  <div className="flex-1">Draw Date: {draw.draw_at}</div>
                              </div>
                          )}
                          { draw.sales_cutoff && (
                              <div className="flex justify-between">
                                  <div className="flex-1">Sales Cutoff: {draw.sales_cutoff}</div>
                              </div>
                          )}
                          { draw.is_main && (
                              <div className="flex justify-between">
                                  <div className="flex-1">Main Prize: Yes</div>
                              </div>
                          )}
                      </div>
                    ))}
                </div>
            )}

            <div className="px-6 py-4">
              <div className="text-grey-darkest text-xs">
                <div className="flex justify-between mb-2">
                  <div className="flex-1"> Raffle Date: </div>
                  <div className="flex-1 text-right"> {data.event.end_at} </div>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex-1"> Purchased: </div>
                  <div className="flex-1 text-right"> {ticket.purchase_time} </div>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex-1"> Device: </div>
                  <div className="flex-1 text-right"> 99 </div>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex-1"> Ticket Price: </div>
                  <div className="flex-1 text-right"> {formatCurrency(ticket.amount)} </div>
                </div>
                {data.game.id === 3 && (
                  <div className="flex justify-between mb-2">
                    <div className="flex-1"> Envelope #: </div>
                    <div className="flex-1 text-right"> {data.envelope} </div>
                  </div>
                )}
                <div className="flex justify-between mb-2">
                  <div className="flex-1"> RID: </div>
                  <div className="flex-1 text-right"> {data.event.id} </div>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex-1"> Reference #: </div>
                  <div className="flex-1 text-right"> {ticket.reference} </div>
                </div>
                {data.beneficiary && (
                  <div className="flex justify-between mb-2">
                    <div className="flex-1"> {language.en.beneficiary_ticket_label} </div>
                    <div className="flex-1 text-right"> {data.beneficiary.name} </div>
                  </div>
                )}
            </div>
            </div>
            {data.nonprofit.barcode_position === "middle" && (
              <div className="p-2">
                <img className="w-full" src={`data:image/png;base64,${ticket.barcode}`} alt="Barcode" />
              </div>
            )}
            <div className="p-2">
              <img
                src={`${data.nonprofit.web_middle_url}`}                
                onError={(e) => { e.target.src = blankImage }}
                alt="Logo"
                className="block mx-auto"
              />
            </div>
            <div className="px-6 py-4 text-xs">
              {data.nonprofit.web_ticket_text_header !== null && (
                <p className="mb-4 font-bold text-center">{data.nonprofit.web_ticket_text_header}</p>
              )}
              {data.nonprofit.web_ticket_text !== null && (
                <p className="mb-4">
                  {data.nonprofit.web_ticket_text.split('\n').map((item, key) => {
                    return <span key={key}>{item}<br /></span>
                  })}
                </p>
              )}
              {data.nonprofit.web_ticket_text_footer !== null && (
                <p className="mb-4 font-bold text-center">{data.nonprofit.web_ticket_text_footer}</p>
              )}
            </div>
            <div className="p-2">
              <img
                src={`${data.nonprofit.web_middle_e_url}`}                
                onError={(e) => { e.target.src = blankImage }}
                alt="Logo"
                className="block mx-auto"
              />
            </div>
            <div className="p-2">
              <img
                src={`${data.nonprofit.web_footer_url}`}                
                onError={(e) => { e.target.src = blankImage }}
                alt="Logo"
                className="block mx-auto"
              />
            </div>
            {data.nonprofit.barcode_position === "bottom" && (
              <div className="p-2">
                <img className="w-full" src={`data:image/png;base64,${ticket.barcode}`} alt="Barcode" />
              </div>
            )}
          </div>
        ))}
        {(data.message && !data.tickets) && (
          <div className="flex flex-wrap mb-6">
            <div className="w-full md:w-1/2">
              <Alert
                Alertvisible={false}
                error={data.message}
                success={false}
                message={data.message}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
Print.contextType = AppContext;

export default PrintSuper;
